import { css } from '@emotion/react';

export const insuranceAccordionSectionContainerStyles = (isSmallDevice: boolean) =>
  css({
    display: isSmallDevice ? 'block' : 'flex',
    alignItems: 'center',
    marginBottom: '16px',
    justifyContent: 'space-between',
    ':has(> :only-child)': {
      justifyContent: 'flex-end',
    },
  });
